var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("input", {
    ref: "input",
    attrs: { type: "text", placeholder: _vm.placeholder, size: _vm.size },
    domProps: { value: _vm.value },
    on: {
      keydown: _vm.onKeydown,
      input: _vm.onInput,
      focus: _vm.onFocus,
      blur: _vm.onBlur,
      change: _vm.onChange,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }